import router from '../../routes/index.js';
import kit from '../../../common/js/kit';
let urlMap = {
    url: `${process.env.VUE_APP_BASE_URL}/api/v1`
    // url: `/dev-api`
};// eslint-disable-line

const apiMap = {
    login: {
        method: 'post',
        url: urlMap.url + '/user/login'
    },
    userRecover: {
        method: 'post',
        url: urlMap.url + '/user/recover'
    },
    logout: {
        method: 'post',
        url: urlMap.url + '/user/logout'
    },
    userDelete: {
        method: 'delete',
        url: urlMap.url + '/user'
    },
    userLock: {
        method: 'post',
        url: urlMap.url + '/user/lock'
    },
    userUnlock: {
        method: 'post',
        url: urlMap.url + '/user/unlock'
    },
    userList: {
        method: 'post',
        url: urlMap.url + '/user/list'
    },
    resetpassword: {
        method: 'post',
        url: urlMap.url + '/user/resetpassword'
    },
    userUpdate: {
        method: 'put',
        url: urlMap.url + '/user/update'
    },
    register: {
        method: 'post',
        url: urlMap.url + '/user/register'
    },
    upload: {
        method: 'post',
        url: urlMap.url + '/upload'
    },
    userInfo: {
        method: 'get',
        url: urlMap.url + '/user/info?uid={uid}'
    },
    professionList: {
        method: 'get',
        url: urlMap.url + '/profession/list'
    },
    groupList: {
        method: 'get',
        url: urlMap.url + '/group/list'
    },
    areaList: {
        method: 'get',
        url: urlMap.url + '/area/list'
    },
    refreshResourceList: {
        method: 'get',
        url: urlMap.url + '/model_resource/list_model_resource?model_name={model_name}&category_type={category_type}&category_name={category_name}&page_no={page_no}&page_size={page_size}&model_resource_category={model_resource_category}&status={status}'
    },
    majorList: {
        method: 'get',
        url: urlMap.url + '/major/list'
    },
    industryList: {
        method: 'get',
        url: urlMap.url + '/industry/list'
    },
    metaList: {
        method: 'get',
        url: urlMap.url + '/metacategory/list'
    },
    statusList: {
        method: 'get',
        url: urlMap.url + '/status/list'
    },
    functionList: {
        method: 'get',
        url: urlMap.url + '/function/list'
    },
    structVersion: {
        method: 'put',
        url: urlMap.url + '/device/struct/version'
    },
    addBasicProperty: {
        method: 'post',
        url: urlMap.url + '/device/basic/property'
    },
    addExtendedProperty: {
        method: 'post',
        url: urlMap.url + '/device/extended/property'
    },
    delExtendedProperty: {
        method: 'delete',
        url: urlMap.url + '/device/extended/property'
    },
    editBasicProperty: {
        method: 'put',
        url: urlMap.url + '/device/basic/property'
    },
    editExtendedProperty: {
        method: 'put',
        url: urlMap.url + '/device/extended/property'
    },
    editBehavior: {
        method: 'put',
        url: urlMap.url + '/device/behavior'
    },
    getPropertyList: {
        method: 'get',
        url: urlMap.url + '/device/extended/property/list?page={page}&pageSize={pageSize}&sceneId={sceneId}'
    },
    getStructInfo: {
        method: 'get',
        url: urlMap.url + '/device/struct/info?structId={structId}&sceneId={sceneId}'
    },
    getTypeList: {
        method: 'get',
        url: urlMap.url + '/device/type/list?sceneId={sceneId}'
    },
    getVariableTypeList: {
        method: 'get',
        url: urlMap.url + '/variableType/list?sceneId={sceneId}'
    },
    getBehaviorTypeList: {
        method: 'get',
        url: urlMap.url + '/behaviorType/list?sceneId={sceneId}'
    },
    // <model_resource>
    getToolRelatedCategory: {
        method: 'get',
        url: urlMap.url + '/model_resource/category'
    },
    addNewCategory: {
        method: 'post',
        url: urlMap.url + '/model_resource/category'
    },
    addModelResource: {
        method: 'post',
        url: urlMap.url + '/model_resource/add'
    },
    getModelResourceList: {
        method: 'get',
        url: urlMap.url + '/model_resource/list_model_resource?model_name={model_name}&category_type={category_type}&category_name={category_name}&page_no={page_no}&page_size={page_size}&model_resource_category={model_resource_category}'
    },
    updateModelResource: {
        method: 'put',
        url: urlMap.url + '/model_resource/update'
    },
    deleteResource: {
        method: 'delete',
        url: urlMap.url + '/model_resource/del'
    }
};

let configApi = {
    setData (map, m) {
        if (['get'].includes(m.method)) {
            for (let k in map) {
                map[k] = kit.typeOf(map[k]) === 'null' ? '' : map[k];
                let reg = new RegExp(`${k}={([^\}]*)}`); // eslint-disable-line
                m.url = m.url.replace(reg, `${k}=${map[k]}`);
            }
            m.url = m.url.replace(/{([^\}]*})/g, '');// eslint-disable-line
        } else {
            m.data = map;
        }
        m.router = router;
        m.routerName = m.router.apps[0]._route.name;
        m.query = m.router.apps[0]._route.query;
        m.projectType = 'management';
        return m;
    }
};

for (let k in apiMap) {
    configApi[k] = function (map) {
        let m = Object.assign({}, apiMap[k]);
        return this.setData(map, m);
    };
}

export default configApi;
